import axiosInstance from "../../api/axiosConfig";
import { getApiBaseUrl } from "../../baseUrl";

export interface VagaInput {
  nomeVaga: string;
  cargo: string;
  salario: number | null;
  descricaoVaga: string;
  ativo: boolean;
  idEmpresa: number;
  dataCriacao?: string;
}

export interface VagaResponse {
  id: number;
  nome_vaga: string;
  cargo: string;
  salario: number;
  descricao_vaga: string;
  ativo: boolean;
  id_empresa: {
    id: number;
  };
}

export const cadastrarVaga = async (
  vaga: VagaInput,
): Promise<{ data: VagaResponse }> => {
  const apiUrl = getApiBaseUrl();
  const url = `${apiUrl}/vagas`;

  try {
    const response = await axiosInstance.post(url, vaga, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return { data: response.data };
  } catch (error) {
    console.error("Erro ao cadastrar vaga:", error);
    throw error;
  }
};

export const listarVagasPorEmpresa = async (
  empresaId: number,
): Promise<{ data: VagaResponse[] }> => {
  const apiUrl = getApiBaseUrl();

  try {
    const response = await axiosInstance.get(`${apiUrl}/vagas/empresa/${empresaId}`);
    return { data: response.data };
  } catch (error) {
    console.error("Erro ao listar vagas:", error);
    throw error;
  }
};

export const atualizarVagaCadastro = async (
  id: number,
  vaga: VagaInput,
): Promise<{ data: VagaResponse }> => {
  const apiUrl = getApiBaseUrl();

  try {
    const response = await axiosInstance.put(`${apiUrl}/vagas/${id}`, vaga);
    return { data: response.data };
  } catch (error) {
    console.error("Erro ao atualizar vaga:", error);
    throw error;
  }
};

export const deletarVaga = async (id: number): Promise<void> => {
  const apiUrl = getApiBaseUrl();

  try {
    await axiosInstance.delete(`${apiUrl}/vagas/${id}`);
  } catch (error) {
    console.error("Erro ao deletar vaga:", error);
    throw error;
  }
};
